/** PKCE-style proof between two hosts (ADR 0013): the target app keeps a random verifier and
 *  sends only its SHA-256 (the challenge) through `accounts.`; the code is worthless without it. */
const VERIFIER_KEY = 'sentinel.handoff.verifier';
const VERIFIER_BYTES = 48;

function base64url(bytes: Uint8Array): string {
  let text = '';
  for (const byte of bytes) text += String.fromCharCode(byte);
  return btoa(text).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export async function challengeOf(verifier: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  return base64url(new Uint8Array(digest));
}

/** A new verifier, kept in this tab only until the callback reads it. */
export function newVerifier(): string {
  const verifier = base64url(crypto.getRandomValues(new Uint8Array(VERIFIER_BYTES)));
  sessionStorage.setItem(VERIFIER_KEY, verifier);
  return verifier;
}

/** The verifier of the pending round trip, read once. */
export function takeVerifier(): string | null {
  const verifier = sessionStorage.getItem(VERIFIER_KEY);
  sessionStorage.removeItem(VERIFIER_KEY);
  return verifier;
}
